import styled, { css } from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import {
  grey4,
  grey5,
  grey6,
  red1,
  red7,
  green1,
  green7,
} from 'approot/shared/styles/colours.style';
import {
  hideNumberStepper,
  NumberInputStyled,
} from 'approot/shared/styles/inputs.style';
import {
  FlexCentreAlign,
  FlexRightAlign,
  flexCentreAlignCss,
  FlexSpaceBetween,
} from 'approot/shared/styles/flex.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import {
  spacing12,
  spacing24,
  marginCss,
  MarginProps,
} from 'approot/shared/styles/spacing.style';
import { fontWeightBold } from 'approot/shared/styles/typography.style';
import { INPUT_WIDTH_SMALL, equationFieldCss } from './equation-response.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';

type EquationResponseProps = {
  $vertical?: boolean;
} & MarginProps;

export const EquationResponseFormWrapper = styled.div<EquationResponseProps>`
  ${() =>
    marginCss({
      $marginBottom: 40,
    })}

  border: 1px solid ${grey4};
  border-radius: ${rem(borderRadius8)};
  padding: ${rem(spacing24)};
  width: 100%;
  max-width: ${({ $vertical }) => rem($vertical ? 280 : 640)};

  ${({ $vertical }) =>
    !$vertical &&
    css`
      ${flexCentreAlignCss}
      flex-direction: column;

      ${mediaUp.sm`
        flex-direction: row;
      `}
    `}
`;

type EquationResponseInputAnswerProps = {
  $hasError?: boolean;
  $isCorrect?: boolean;
  $isIncorrect?: boolean;
};

export const EquationResponseInputAnswer = styled(
  NumberInputStyled
)<EquationResponseInputAnswerProps>`
  ${() => useActivityBuilderFontStyles()}
  ${equationFieldCss}

  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  width: 100%;
  text-align: center;

  ::placeholder {
    color: ${grey6};
    font-weight: ${fontWeightBold};
  }

  ${({ $hasError, $isIncorrect }) =>
    ($hasError || $isIncorrect) &&
    `
    border: 1px solid ${red7};
  `}

  ${({ $isIncorrect }) =>
    $isIncorrect &&
    `
    background-color: ${red1};

    &:disabled {
      background-color: ${red1};
      border: 1px solid ${red7};
    }
  `}

  ${({ $isCorrect }) =>
    $isCorrect &&
    `
    border: 1px solid ${green7};
    background-color: ${green1};

    &:disabled {
      border: 1px solid ${green7};
      background-color: ${green1};
    }
  `}

  ${mediaUp.md`
    width: ${rem(INPUT_WIDTH_SMALL)};
  `}

  ${hideNumberStepper}
`;

export const EquationResponseInputAnswerVertical = styled(
  EquationResponseInputAnswer
)`
  ${() => useActivityBuilderFontStyles()}
  ${equationFieldCss}
  text-align: right;
  width: 100%;
`;

export const EquationResponseBox = styled(FlexCentreAlign)`
  ${() => useActivityBuilderFontStyles()}
  ${equationFieldCss}

  border-bottom: 4px solid ${grey5};
  border-radius: 0;
  width: 100%;

  ${mediaUp.md`
    width: ${rem(INPUT_WIDTH_SMALL)};
  `}
`;

export const EquationResponseBoxVertical = styled(FlexRightAlign)`
  ${() => useActivityBuilderFontStyles()}
  ${equationFieldCss}
  text-align: right;
  margin-bottom: ${rem(2)};
  border: none;
`;

export const EquationResponseOperator = styled.div`
  ${() => useActivityBuilderFontStyles()}
  margin: 0 ${rem(spacing12)};
`;

export const EquationResponseOperatorWrapper = styled(FlexSpaceBetween)``;
